import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "post-detail-container" }
const _hoisted_2 = {
  key: 0,
  class: "loading"
}
const _hoisted_3 = {
  key: 1,
  class: "post-detail-content"
}
const _hoisted_4 = { class: "post-header" }
const _hoisted_5 = { class: "user-info" }
const _hoisted_6 = { class: "user-info-content" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "user-text" }
const _hoisted_9 = { class: "create-time" }
const _hoisted_10 = { class: "post-stats" }
const _hoisted_11 = { class: "post-content" }
const _hoisted_12 = { class: "post-title" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = {
  key: 0,
  class: "media-list"
}
const _hoisted_15 = {
  key: 0,
  class: "image-grid"
}
const _hoisted_16 = { class: "image-wrapper" }
const _hoisted_17 = ["src", "alt", "onClick"]
const _hoisted_18 = { class: "video-wrapper" }
const _hoisted_19 = ["src", "poster"]
const _hoisted_20 = {
  key: 0,
  class: "video-duration"
}
const _hoisted_21 = { class: "image-display" }
const _hoisted_22 = ["src", "alt"]
const _hoisted_23 = { class: "image-counter" }
const _hoisted_24 = { class: "post-actions" }
const _hoisted_25 = {
  key: 0,
  class: "user-actions"
}
const _hoisted_26 = {
  key: 1,
  class: "main-comment-input"
}
const _hoisted_27 = { class: "comment-actions-footer" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = {
  key: 2,
  class: "hot-comment-section"
}
const _hoisted_30 = { class: "comment-item" }
const _hoisted_31 = ["src"]
const _hoisted_32 = { class: "comment-content" }
const _hoisted_33 = { class: "comment-header" }
const _hoisted_34 = { class: "comment-time" }
const _hoisted_35 = { class: "comment-actions" }
const _hoisted_36 = { class: "comment-like-btn" }
const _hoisted_37 = { class: "comments-section" }
const _hoisted_38 = ["src", "onClick"]
const _hoisted_39 = { class: "comment-content" }
const _hoisted_40 = { class: "comment-header" }
const _hoisted_41 = { class: "comment-time" }
const _hoisted_42 = { class: "comment-actions" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = ["onClick"]
const _hoisted_48 = {
  key: 0,
  class: "reply-input-box"
}
const _hoisted_49 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_50 = { class: "comment-actions-footer" }
const _hoisted_51 = ["onClick", "disabled"]
const _hoisted_52 = {
  key: 1,
  class: "replies-container"
}
const _hoisted_53 = {
  key: 2,
  class: "error"
}

import { ref, reactive, onMounted, computed, watch, onUnmounted } from 'vue';

// 定义组件 Props
import { useRoute, useRouter } from 'vue-router';
import { ElMessage, ElMessageBox, ElPagination } from 'element-plus';
import { useStore } from 'vuex';
// 修复导入 - 使用正确的函数名
import { getPostDetail, createComment, likePost, favoritePost, followUser, deleteComment, getCommentList, deletePost } from '@/user/api/post';
import { likeComment } from '@/user/api/interaction';
import { addReport } from '@/user/api/userApi';
import ReportModal from '@/user/views/report/ReportModal.vue';
import OtherUserProfileModal from '@/user/views/user/OtherUserProfileModal.vue'; // 导入用户信息弹窗组件
import { formatDate } from '@/utils/date';
import ChildCommentList from '@/user/views/comment/ChildCommentList.vue';
import EditPostModal from './EditPostModal.vue';
import apiClient from '@/user/api/post';
import MarkdownIt from 'markdown-it';

// 创建MarkdownIt实例
type ExtendedComment = Comment & {
  showReplies?: boolean;
};

// 获取回复按钮的文本

export default /*@__PURE__*/_defineComponent({
  __name: 'PostDetailView',
  props: {
    postId: {}
  },
  setup(__props: any) {

const props = __props;

const md = new MarkdownIt();

// 初始化router和store实例
const router = useRouter(); // 添加router实例
const store = useStore();

// 声明 reportModalRef
const reportModalRef = ref();

// 计算属性获取当前登录用户的ID
const computedUserId = computed(() => {
  const userInfo = store.state.userInfo;
  return userInfo?.id || null;
});

// 获取关注按钮的文本和emoji
const getFollowButtonText = (post: any) => {
  // 检查post是否存在
  if (!post) {
    return ' 👤 关注';
  }
  
  // 互相关注：当 isFollowed=1 且 isFollowerd=1 时，显示"互相关关"和爱心emoji
  if (post.isFollowed === 1 && post.isFollowerd === 1) {
    return ' ❤️ 互相关注';
  }
  // 回关：当 isFollowed=0 且 isFollowerd=1 时，显示"回关"和招手emoji
  else if (post.isFollowed === 0 && post.isFollowerd === 1) {
    return ' 👋 回关';
  }
  // 已关注：当 isFollowed=1 且 isFollowerd=0 时，显示"已关注"和对勾emoji
  else if (post.isFollowed === 1 && post.isFollowerd === 0) {
    return ' ✅ 已关注';
  }
  // 未关注：当两者均为 0 时，显示"关注"和头像emoji
  else {
    return ' 👤 关注';
  }
};

// 编辑帖子相关
const editingPostId = ref<number | null>(null);
const editDialogVisible = ref(false);

// 打开编辑模态框
const openEditModal = () => {
  if (postDetail.value) {
    // 设置编辑的帖子ID
    editingPostId.value = postDetail.value.id;
    editDialogVisible.value = true;
  }
};

// 编辑成功后的回调
const onEditSuccess = () => {
  editDialogVisible.value = false;
  editingPostId.value = null;
  // 重新加载帖子详情
  loadPostDetail();
};

// 确认删除帖子
const confirmDeletePost = async () => {
  try {
    await ElMessageBox.confirm(
      '确定要删除这个帖子吗？此操作不可撤销。',
      '删除确认',
      {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }
    );
    
    if (postDetail.value) {
      // 调用删除帖子的API
      const response = await deletePost(postDetail.value.id);
      
      if (response.code === 1) {
        ElMessage.success('帖子删除成功');
        // 返回上一页
        router.go(-1);
      } else {
        ElMessage.error(response.msg || '删除帖子失败');
      }
    }
  } catch (error) {
    // 用户取消删除或发生错误
    if (error !== 'cancel') {
      console.error('删除帖子失败:', error);
      ElMessage.error('删除帖子失败');
    }
  }
};

// 响应式数据
const postDetail = ref<any /*PostDetail*/ | null>(null);  // 使用 any 类型注解避免 ESLint 报错
const comments = ref<Comment[]>([]); // 评论数据
const totalComments = ref(0); // 评论总数
const loading = ref(true);
const commentsLoading = ref(false); // 评论加载状态

// 添加用户详情模态框相关变量
const showUserProfileModal = ref(false); // 控制用户信息弹窗显示
const selectedUserId = ref(0); // 当前选中的用户ID

// 显示用户信息弹窗
const showUserProfile = (userId: number) => {
  selectedUserId.value = userId;
  showUserProfileModal.value = true;
};

// 计算属性渲染Markdown内容
const renderedContent = computed(() => {
  if (!postDetail.value?.content) return '';
  return md.render(postDetail.value.content);
});

// 分页相关数据
const currentPage = ref(1);
const pageSize = ref(5); // 每页显示5条评论

// 主评论相关数据
const showCommentInput = ref(false);
const mainCommentContent = ref('');
const submittingComment = ref(false);


// 回复相关数据
const showingReplyInput = ref<number | null>(null); // 记录当前显示回复输入框的评论ID
const replyContents = ref<{[key: number]: string}>({}); // 存储各个评论的回复内容
const submittingReply = ref(false); // 是否正在提交回复

// 从 props 或路由参数获取帖子ID
const getPostId = (): number | null => {
  // 优先使用 props 中的 postId，如果没有则尝试从路由参数获取
  if (props?.postId && props.postId > 0) {
    console.log('Using postId from props:', props.postId);
    return props.postId;
  }
  
  try {
    const route = useRoute();
    // 检查 route 和 route.params 是否存在
    if (route && route.params && route.params.postId !== undefined) {
      const routeId = Number(route.params.postId);
      if (!isNaN(routeId) && routeId > 0) {
        console.log('Using postId from route:', routeId);
        return routeId;
      }
    }
  } catch (error) {
    console.error('Error getting route params:', error);
  }
  
  console.error('Could not determine post ID from props or route');
  return null;
};

// 获取当前页的评论
const currentComments = computed(() => {
  return comments.value as ExtendedComment[];
});

// 区分图片和视频
const imageMediaList = computed(() => {
  if (!postDetail.value?.mediaList) return [];
  return postDetail.value.mediaList
    .filter(media => media.mediaType === 1)
    .sort((a, b) => {
      if (a.sortOrder !== null && b.sortOrder !== null) {
        return a.sortOrder - b.sortOrder;
      } else if (a.sortOrder !== null) {
        return -1;
      } else if (b.sortOrder !== null) {
        return 1;
      }
      return a.id - b.id;
    });
});

const videoMediaList = computed(() => {
  if (!postDetail.value?.mediaList) return [];
  return postDetail.value.mediaList
    .filter(media => media.mediaType === 2)
    .sort((a, b) => {
      if (a.sortOrder !== null && b.sortOrder !== null) {
        return a.sortOrder - b.sortOrder;
      } else if (a.sortOrder !== null) {
        return -1;
      } else if (b.sortOrder !== null) {
        return 1;
      }
      return a.id - b.id;
    });
});

const hasImages = computed(() => {
  return imageMediaList.value.length > 0;
});

const hasVideos = computed(() => {
  return videoMediaList.value.length > 0;
});

// 图片预览相关数据
const showImageViewer = ref(false);
const currentIndex = ref(0);

// 当前显示的图片
const currentImage = computed(() => {
  if (imageMediaList.value.length > 0 && currentIndex.value < imageMediaList.value.length) {
    return imageMediaList.value[currentIndex.value];
  }
  return null;
});

// 打开图片预览
const openImageViewer = (index: number) => {
  currentIndex.value = index;
  showImageViewer.value = true;
  // 阻止背景滚动
  document.body.style.overflow = 'hidden';
};

// 关闭图片预览
const closeImageViewer = () => {
  showImageViewer.value = false;
  // 恢复背景滚动
  document.body.style.overflow = '';
};

// 获取图片索引
const getImageIndex = (id: number) => {
  return imageMediaList.value.findIndex(img => img.id === id);
};

// 上一张图片
const prevImage = () => {
  if (currentIndex.value > 0) {
    currentIndex.value--;
  } else {
    currentIndex.value = imageMediaList.value.length - 1; // 循环到最后一张
  }
};

// 下一张图片
const nextImage = () => {
  if (currentIndex.value < imageMediaList.value.length - 1) {
    currentIndex.value++;
  } else {
    currentIndex.value = 0; // 循环到第一张
  }
};

// 键盘事件支持
const handleKeyDown = (e: KeyboardEvent) => {
  if (!showImageViewer.value) return;
  
  if (e.key === 'Escape') {
    closeImageViewer();
  } else if (e.key === 'ArrowLeft') {
    prevImage();
  } else if (e.key === 'ArrowRight') {
    nextImage();
  }
};

// 监听键盘事件
onMounted(() => {
  window.addEventListener('keydown', handleKeyDown);
});

// 组件销毁时移除事件监听
onUnmounted(() => {
  window.removeEventListener('keydown', handleKeyDown);
  // 确保在组件卸载时恢复滚动
  document.body.style.overflow = '';
});

// API基础URL
const apiBaseUrl = computed(() => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;
  return (baseUrl ? baseUrl : '/api'); // 使用三元运算符替代类型断言
});

// 格式化视频时长（秒转为 MM:SS）
const formatDuration = (seconds: number) => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};

// 处理分页变化
const handlePageChange = async (page: number) => {
  console.log('Page changed to:', page);
  currentPage.value = page;
  await loadComments(page, pageSize.value);
};

// 扩展Comment类型，添加显示控制属性
const getReplyButtonText = (comment: ExtendedComment) => {
  // 使用API返回的childCommentCount字段
  const replyCount = comment.childCommentCount || 0;
  return comment.showReplies 
    ? `收起回复 (${replyCount})` 
    : `展开回复 (${replyCount})`;
};

// 处理切换回复显示状态
const toggleReplies = (comment: ExtendedComment) => {
  if (comment.showReplies === undefined) {
    // 如果还没有初始化，则添加一个showReplies属性
    comment.showReplies = true;
  } else {
    comment.showReplies = !comment.showReplies;
  }
};


// 从路由参数获取帖子ID并加载帖子详情
const loadPostDetail = async () => {
  try {
    const postId = getPostId();
    if (!postId || isNaN(postId) || postId <= 0) {
      console.error('Invalid post ID');
      return;
    }

    const response = await getPostDetail(postId);
    // 根据 API 响应处理数据 - API 返回的是 PostDetailResponse 类型
    if (response && response.code === 1 && response.data) {
      postDetail.value = response.data;
      
      currentPage.value = 1; // 重置到第一页
      // 加载第一页评论
      await loadComments(1, pageSize.value);
    } else {
      console.error('Failed to fetch post detail:', response);
    }
  } catch (error) {
    console.error('Error fetching post detail:', error);
  } finally {
    loading.value = false;
  }
};

// 加载评论
const loadComments = async (page: number, size: number) => {
  try {
    commentsLoading.value = true;
    
    const postId = getPostId();
    if (!postId || isNaN(postId) || postId <= 0) {
      console.error('Invalid post ID');
      return;
    }
    
    let response; // 定义response变量
    const params = {
      page: page, // 后端分页从1开始
      pageSize: size,
      postId: postId // 修正类型问题
    };

    console.log('Loading comments with params (attempt 1):', params);

    // 发送请求获取评论列表
    response = await getCommentList(params);
    
    console.log('Full Comment API Response (attempt 1):', response);
    
    // 根据API响应处理数据
    let records: Comment[] = []; // 修复：明确指定类型
    let total = 0;
    
    if (response && response.code === 1) {
      records = response.data?.records || [];
      total = response.data?.total || 0;
      
      // 调试：输出第一条评论的字段
      if (records.length > 0) {
        console.log('First comment fields:', Object.keys(records[0]));
        console.log('First comment data:', records[0]);
        records.forEach((comment, index) => {
          console.log(`Comment ${index} childCommentCount:`, comment.childCommentCount);
        });
      }
    }
    
    comments.value = records;
    totalComments.value = total;
    
    console.log(`Successfully loaded ${comments.value.length} comments out of total ${totalComments.value}`);
    console.log('First few comment data:', comments.value.slice(0, 2));
    
    // 检查评论是否有回复数字段
    if (comments.value.length > 0) {
      console.log('Checking first comment for childCommentCount:', comments.value[0].childCommentCount);
    }
  } catch (error) {
    console.error('请求评论列表时发生错误:', error);
    console.error('Error details:', error instanceof Error ? error.message : error);
    comments.value = [];
    totalComments.value = 0;
  } finally {
    commentsLoading.value = false;
  }
};

// 点赞/取消点赞
const toggleLike = async () => {
  if (!postDetail.value) return;
  
  try {
    // 如果用户未登录，提示登录
    if (!store.getters.isAuthenticated) {
      ElMessage.warning('请先登录');
      return;
    }

    // 调用API进行点赞/取消点赞
    const response = await likePost(postDetail.value.id);

    if (response && response.code === 1) {
      // 操作成功，重新加载数据以获取最新状态
      await loadPostDetail();
      ElMessage.success(postDetail.value.isLiked ? '已取消点赞' : '已点赞');
    } else {
      ElMessage.error(response.msg || '操作失败');
    }
  } catch (error: any) {
    console.error('点赞操作失败:', error);
    ElMessage.error('点赞操作失败，请稍后再试');
  }
};

// 收藏/取消收藏
const toggleFavorite = async () => {
  if (!postDetail.value) return;
  
  try {
    // 如果用户未登录，提示登录
    if (!store.getters.isAuthenticated) {
      ElMessage.warning('请先登录');
      return;
    }

    // 调用API进行收藏/取消收藏
    const response = await favoritePost(postDetail.value.id);

    if (response && response.code === 1) {
      // 操作成功，重新加载数据以获取最新状态
      await loadPostDetail();
      ElMessage.success(postDetail.value.isFavorited ? '已取消收藏' : '已收藏');
    } else {
      ElMessage.error(response.msg || '操作失败');
    }
  } catch (error: any) {
    console.error('收藏操作失败:', error);
    ElMessage.error('收藏操作失败，请稍后再试');
  }
};

// 关注/取消关注用户
const toggleFollowDetail = async (post: any) => {  // 使用 any 类型避免 ESLint 报错
  try {
    // 如果用户未登录，提示登录
    if (!store.getters.isAuthenticated) {
      ElMessage.warning('请先登录');
      return;
    }

    // 确保post对象存在
    if (!post) {
      ElMessage.error('用户信息不存在');
      return;
    }

    // 调用API关注/取消关注用户
    const response = await followUser(post.userId);
    if (response && response.code === 1) {
      // 检查响应数据是否存在
      let newFollowStatus;
      let actionText;
      
      if (response.data) {
        // 更新帖子的关注状态
        if (postDetail.value) {
          postDetail.value.isFollowed = response.data.isFollowed;
          // 同时更新isFollowerd状态，如果后端返回了该字段
          if (response.data.isFollowerd !== undefined) {
            postDetail.value.isFollowerd = response.data.isFollowerd;
          }
        }
        
        // 根据API返回的新状态判断应该显示什么提示
        newFollowStatus = response.data.isFollowed;
        actionText = newFollowStatus === 1 ? '关注用户成功' : '已取消关注';
      } else {
        // 如果响应中没有数据，根据当前状态翻转来推断新状态
        if (postDetail.value) {
          // 翻转当前状态作为新状态
          newFollowStatus = postDetail.value.isFollowed ? 0 : 1;
          postDetail.value.isFollowed = newFollowStatus;
          actionText = newFollowStatus === 1 ? '关注用户成功' : '已取消关注';
        } else {
          // 如果postDetail.value也不存在，使用传入的post参数
          newFollowStatus = post.isFollowed ? 0 : 1;
          actionText = newFollowStatus === 1 ? '关注用户成功' : '已取消关注';
        }
      }
      
      ElMessage.success(actionText);
    } else {
      ElMessage.error(response.msg || '操作失败');
    }
  } catch (error: any) {
    console.error('关注操作失败:', error);
    ElMessage.error('关注操作失败，请稍后再试');
  }
};

// 举报帖子
const openReportDialog = () => {
  if (!postDetail.value) return;
  
  // 检查是否为自己发布的帖子，如果是则不允许举报
  if (computedUserId.value === postDetail.value.userId) {
    ElMessage.warning('不能举报自己的帖子');
    return;
  }
  
  // 调用子组件的打开对话框方法
  reportModalRef.value?.openReportDialog(1, postDetail.value.id);
};

// 举报评论
const openCommentReportDialog = (commentId: number) => {
  // 调用子组件的打开对话框方法
  reportModalRef.value?.openReportDialog(2, commentId); // 2 表示评论类型
};

// 处理举报事件（来自子评论）
const handleReportEvent = (payload: { targetType: number, targetId: number }) => {
  reportModalRef.value?.openReportDialog(payload.targetType, payload.targetId);
};

// 点赞/取消点赞评论
const toggleCommentLike = async (comment: Comment) => {
  try {
    // 如果用户未登录，提示登录
    if (!store.getters.isAuthenticated) {
      ElMessage.warning('请先登录');
      return;
    }

    // 乐观更新：先保存当前状态，用于失败时回滚
    const previousIsLiked = comment.isLiked;
    const previousLikeCount = comment.likeCount;
    
    // 立即更新UI状态（乐观更新）
    comment.isLiked = previousIsLiked === 1 ? 0 : 1;
    comment.likeCount = previousIsLiked === 1 ? previousLikeCount - 1 : previousLikeCount + 1;

    // 调用API进行点赞/取消点赞评论
    const response = await likeComment(comment.id);

    if (response && response.code === 1) {
      // API调用成功，保持乐观更新的状态
      ElMessage.success(comment.isLiked === 1 ? '已点赞' : '已取消点赞');
      
      // 同步更新帖子详情中的评论总数（如果存在）
      if (postDetail.value) {
        postDetail.value.commentCount = totalComments.value;
      }
    } else {
      // API调用失败，回滚UI状态
      comment.isLiked = previousIsLiked;
      comment.likeCount = previousLikeCount;
      ElMessage.error(response.msg || '操作失败');
    }
  } catch (error: any) {
    // 发生异常，回滚UI状态
    console.error('评论点赞操作失败:', error);
    ElMessage.error('评论点赞操作失败，请稍后再试');
    
    // 回滚到之前的状态
    comment.isLiked = comment.isLiked === 1 ? 0 : 1; // 反转回来
    // 由于可能有其他用户同时操作，重新加载数据以保证一致性
    await loadComments(currentPage.value, pageSize.value);
  }
};

// 删除评论
const deleteCurrentComment = async (comment: Comment) => {
  try {
    await ElMessageBox.confirm(
      '确定要删除这个评论吗？此操作不可撤销。',
      '删除确认',
      {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }
    );
    
    // 调用删除评论的API
    const response = await deleteComment(comment.id);  // 使用导入的API函数
    
    if (response && response.code === 1) {
      ElMessage.success('评论删除成功');
      // 重新加载评论列表
      await loadComments(currentPage.value, pageSize.value);
      
      // 更新帖子的评论数
      if (postDetail.value) {
        postDetail.value.commentCount--;
      }
    } else {
      ElMessage.error(response.msg || '删除评论失败');
    }
  } catch (error) {
    // 用户取消删除或发生错误
    if (error !== 'cancel') {
      console.error('删除评论失败:', error);
      ElMessage.error('删除评论失败');
    }
  }
};

// 提交主评论
const submitPostComment = async () => {
  if (!mainCommentContent.value.trim()) {
    ElMessage.warning('请输入评论内容');
    return;
  }

  const postId = getPostId();
  if (!postId) {
    ElMessage.error('帖子ID不能为空');
    return;
  }

  submittingComment.value = true;
  
  // 显示审核中提示
  ElMessage.info('评论提交成功，正在审核中...');

  try {
    // 调用API创建评论
    const response = await createComment({
      postId: postId, // 这里应该传入数字类型
      parentId: undefined,  // 父评论ID，这里为undefined表示一级评论
      content: mainCommentContent.value.trim()
    });

    if (response && response.code === 1) {
      ElMessage.success(response.msg || '评论发表成功');
      
      // 重置评论框
      mainCommentContent.value = '';
      showCommentInput.value = false;
      
      // 重新加载评论列表
      await loadComments(currentPage.value, pageSize.value);
      
      // 更新帖子的评论数
      if (postDetail.value) {
        postDetail.value.commentCount++;
      }
      
    } else {
      ElMessage.error(response?.msg || '评论发表失败');
    }
  } catch (error) {
    console.error('提交评论失败:', error);
    ElMessage.error('提交评论失败，请稍后重试');
  } finally {
    submittingComment.value = false;
  }
};

// 取消主评论
const cancelMainComment = () => {
  showCommentInput.value = false;
  mainCommentContent.value = '';
};

// 显示回复输入框
const showReplyInput = (commentId: number) => {
  // 如果当前显示的就是这个评论的输入框，则隐藏它
  if (showingReplyInput.value === commentId) {
    showingReplyInput.value = null;
  } else {
    showingReplyInput.value = commentId;
    // 初始化回复内容为空字符串（如果尚未初始化）
    if (!(commentId in replyContents.value)) {
      replyContents.value[commentId] = '';
    }
  }
};

// 提交回复
const submitReply = async (commentId: number, parentName: string) => {
  const replyContent = replyContents.value[commentId];
  
  if (!replyContent || !replyContent.trim()) {
    ElMessage.warning('请输入回复内容');
    return;
  }

  const postId = getPostId();
  if (!postId) {
    ElMessage.error('帖子ID不能为空');
    return;
  }

  submittingReply.value = true;
  
  // 显示审核中提示
  ElMessage.info('回复提交成功，正在审核中...');

  try {
    // 调用API创建评论
    const response = await createComment({
      postId: postId,
      parentId: commentId,  // 父评论ID，这里是具体的评论ID
      content: replyContent.trim()
    });

    if (response && response.code === 1) {
      ElMessage.success('回复发表成功');
      
      // 清空该评论的回复内容并隐藏输入框
      replyContents.value[commentId] = '';
      showingReplyInput.value = null;
      
      // 重新加载评论列表
      await loadComments(currentPage.value, pageSize.value);
      
      // 更新帖子的评论数
      if (postDetail.value) {
        postDetail.value.commentCount++;
      }
      
    } else {
      ElMessage.error(response?.msg || '回复发表失败');
    }
  } catch (error: any) {
    console.error('提交回复失败:', error);
    ElMessage.error('提交回复失败，请稍后再试');
  } finally {
    submittingReply.value = false;
  }
};

// 取消回复
const cancelReply = () => {
  showingReplyInput.value = null;
};

// 监听路由参数变化，重新加载数据
const route = useRoute();
watch(
  () => route.params.postId,
  (newPostId) => {
    if (newPostId) {
      const postId = Number(newPostId);
      if (!isNaN(postId) && postId > 0) {
        console.log('Route param changed, reloading post detail for ID:', postId);
        // 重新加载帖子详情
        loading.value = true;
        postDetail.value = null;
        comments.value = []; // 清空评论
        loadPostDetail();
      }
    }
  }
);

// 监听 props 变化
watch(
  () => props?.postId,
  (newPostId) => {
    if (newPostId && newPostId > 0) {
      console.log('Prop changed, reloading post detail for ID:', newPostId);
      // 重新加载帖子详情
      loading.value = true;
      loadPostDetail();
    }
  }
);

onMounted(() => {
  console.log('PostDetailView mounted, attempting to load post detail');
  // 滚动到页面顶部
  window.scrollTo(0, 0);
  loadPostDetail();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, "加载中..."))
        : (postDetail.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("img", {
                      src: postDetail.value.userAvatar,
                      alt: "用户头像",
                      class: "avatar",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (showUserProfile(postDetail.value.userId))),
                      style: {"cursor":"pointer"}
                    }, null, 8, _hoisted_7),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("h3", null, _toDisplayString(postDetail.value.name), 1),
                      _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(formatDate)(postDetail.value.createTime)), 1),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("span", null, [
                          _cache[10] || (_cache[10] = _createElementVNode("i", { class: "icon-view" }, null, -1)),
                          _createTextVNode(" 浏览: " + _toDisplayString(postDetail.value.viewCount), 1)
                        ]),
                        _createElementVNode("span", null, [
                          _cache[11] || (_cache[11] = _createElementVNode("i", { class: "icon-like" }, null, -1)),
                          _createTextVNode(" 点赞: " + _toDisplayString(postDetail.value.likeCount), 1)
                        ]),
                        _createElementVNode("span", null, [
                          _cache[12] || (_cache[12] = _createElementVNode("i", { class: "icon-favorite" }, null, -1)),
                          _createTextVNode(" 收藏: " + _toDisplayString(postDetail.value.favoriteCount), 1)
                        ]),
                        _createElementVNode("span", null, [
                          _cache[13] || (_cache[13] = _createElementVNode("i", { class: "icon-comment" }, null, -1)),
                          _createTextVNode(" 评论: " + _toDisplayString(postDetail.value.commentCount), 1)
                        ])
                      ])
                    ])
                  ]),
                  (postDetail.value && computedUserId.value !== postDetail.value.userId)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (toggleFollowDetail(postDetail.value)), ["stop"])),
                        class: _normalizeClass(['follow-btn', { followed: postDetail.value?.isFollowed === 1 }])
                      }, _toDisplayString(getFollowButtonText(postDetail.value)), 3))
                    : _createCommentVNode("", true),
                  (postDetail.value && computedUserId.value !== postDetail.value.userId)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "report-btn",
                        onClick: openReportDialog
                      }, [...(_cache[14] || (_cache[14] = [
                        _createElementVNode("i", { class: "icon-report" }, "举报", -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode(EditPostModal, {
                modelValue: editDialogVisible.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((editDialogVisible).value = $event)),
                "post-id": editingPostId.value,
                onSaveSuccess: onEditSuccess
              }, null, 8, ["modelValue", "post-id"]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("h2", _hoisted_12, _toDisplayString(postDetail.value.title), 1),
                _createElementVNode("div", {
                  class: "post-body",
                  innerHTML: renderedContent.value
                }, null, 8, _hoisted_13),
                (postDetail.value.mediaList && postDetail.value.mediaList.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      (hasImages.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imageMediaList.value, (media) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: media.id,
                                class: "media-item"
                              }, [
                                _createElementVNode("div", _hoisted_16, [
                                  _createElementVNode("img", {
                                    src: `${apiBaseUrl.value}${media.mediaUrl}`,
                                    alt: `Media ${media.id}`,
                                    onClick: ($event: any) => (openImageViewer(getImageIndex(media.id))),
                                    style: {"cursor":"pointer"}
                                  }, null, 8, _hoisted_17)
                                ])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(videoMediaList.value, (media) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `video-${media.id}`,
                          class: "video-full-width"
                        }, [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("video", {
                              src: `${apiBaseUrl.value}${media.mediaUrl}`,
                              poster: media.thumbnailUrl ? `${apiBaseUrl.value}${media.thumbnailUrl}` : '',
                              controls: "",
                              preload: "metadata"
                            }, " 您的浏览器不支持视频播放 ", 8, _hoisted_19),
                            (media.duration)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(formatDuration(media.duration)), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (showImageViewer.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "image-viewer-overlay",
                    onClick: closeImageViewer
                  }, [
                    _createElementVNode("div", {
                      class: "image-viewer-content",
                      onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      (imageMediaList.value.length > 1)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "nav-btn prev-btn",
                            onClick: _withModifiers(prevImage, ["stop"])
                          }, "❮"))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("img", {
                          src: `${apiBaseUrl.value}${currentImage.value?.mediaUrl}`,
                          alt: `Image ${currentImage.value?.id}`
                        }, null, 8, _hoisted_22),
                        _createElementVNode("div", _hoisted_23, _toDisplayString(currentIndex.value + 1) + " / " + _toDisplayString(imageMediaList.value.length), 1)
                      ]),
                      (imageMediaList.value.length > 1)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "nav-btn next-btn",
                            onClick: _withModifiers(nextImage, ["stop"])
                          }, "❯"))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        class: "close-btn",
                        onClick: closeImageViewer
                      }, "✕")
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("button", {
                  onClick: toggleLike,
                  class: _normalizeClass(['action-btn', { liked: postDetail.value.isLiked === 1 }])
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(postDetail.value.isLiked === 1 ? 'icon-liked' : 'icon-like')
                  }, null, 2),
                  _createTextVNode(" " + _toDisplayString(postDetail.value.isLiked === 1 ? '已点赞' : '点赞') + " (" + _toDisplayString(postDetail.value.likeCount) + ") ", 1)
                ], 2),
                _createElementVNode("button", {
                  class: "action-btn comment-btn",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (showCommentInput.value = !showCommentInput.value))
                }, [...(_cache[15] || (_cache[15] = [
                  _createElementVNode("i", { class: "icon-comment" }, null, -1),
                  _createTextVNode(" 评论 ", -1)
                ]))]),
                _createElementVNode("button", {
                  onClick: toggleFavorite,
                  class: _normalizeClass(['action-btn', { favorited: postDetail.value.isFavorited === 1 }])
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(postDetail.value.isFavorited === 1 ? 'icon-favorited' : 'icon-favorite')
                  }, null, 2),
                  _createTextVNode(" " + _toDisplayString(postDetail.value.isFavorited === 1 ? '已收藏' : '收藏') + " (" + _toDisplayString(postDetail.value.favoriteCount) + ") ", 1)
                ], 2),
                (computedUserId.value === postDetail.value?.userId)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createElementVNode("button", {
                        class: "action-btn edit-btn",
                        onClick: openEditModal
                      }, [...(_cache[16] || (_cache[16] = [
                        _createElementVNode("i", { class: "icon-edit" }, null, -1),
                        _createTextVNode(" 编辑 ", -1)
                      ]))]),
                      _createElementVNode("button", {
                        class: "action-btn delete-btn",
                        onClick: confirmDeletePost
                      }, [...(_cache[17] || (_cache[17] = [
                        _createElementVNode("i", { class: "icon-delete" }, null, -1),
                        _createTextVNode(" 删除 ", -1)
                      ]))])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (showCommentInput.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((mainCommentContent).value = $event)),
                      placeholder: "写下你的评论...",
                      class: "comment-textarea",
                      rows: "4"
                    }, null, 512), [
                      [_vModelText, mainCommentContent.value]
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("button", {
                        onClick: cancelMainComment,
                        class: "cancel-btn"
                      }, "取消"),
                      _createElementVNode("button", {
                        onClick: submitPostComment,
                        class: "submit-btn",
                        disabled: submittingComment.value
                      }, "发送", 8, _hoisted_28)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (postDetail.value.hotComment)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _cache[19] || (_cache[19] = _createElementVNode("h3", null, "热门评论", -1)),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("img", {
                        src: postDetail.value.hotComment.userAvatar,
                        alt: "评论者头像",
                        class: "comment-avatar",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (showUserProfile(postDetail.value.hotComment.userId))),
                        style: {"cursor":"pointer"}
                      }, null, 8, _hoisted_31),
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("strong", null, _toDisplayString(postDetail.value.hotComment.name), 1),
                          _createElementVNode("span", _hoisted_34, _toDisplayString(_unref(formatDate)(postDetail.value.hotComment.createTime)), 1)
                        ]),
                        _createElementVNode("p", null, _toDisplayString(postDetail.value.hotComment.content), 1),
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("button", _hoisted_36, [
                            _cache[18] || (_cache[18] = _createElementVNode("i", { class: "icon-like" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(postDetail.value.hotComment.likeCount), 1)
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("h3", null, "全部评论 (" + _toDisplayString(totalComments.value) + ")", 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentComments.value, (comment) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: comment.id,
                    class: "comment-item"
                  }, [
                    _createElementVNode("img", {
                      src: comment.userAvatar,
                      alt: "评论者头像",
                      class: "comment-avatar",
                      onClick: ($event: any) => (showUserProfile(comment.userId)),
                      style: {"cursor":"pointer"}
                    }, null, 8, _hoisted_38),
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("strong", null, _toDisplayString(comment.name), 1),
                        _createElementVNode("span", _hoisted_41, _toDisplayString(_unref(formatDate)(comment.createTime)), 1)
                      ]),
                      _createElementVNode("p", null, _toDisplayString(comment.content), 1),
                      _createElementVNode("div", _hoisted_42, [
                        (comment.childCommentCount && comment.childCommentCount > 0)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "show-replies-btn",
                              onClick: ($event: any) => (toggleReplies(comment))
                            }, [
                              _cache[20] || (_cache[20] = _createElementVNode("i", { class: "icon-reply" }, null, -1)),
                              _createTextVNode(_toDisplayString(getReplyButtonText(comment)), 1)
                            ], 8, _hoisted_43))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          class: "comment-reply-btn",
                          onClick: ($event: any) => (showReplyInput(comment.id))
                        }, [...(_cache[21] || (_cache[21] = [
                          _createElementVNode("i", { class: "icon-reply" }, null, -1),
                          _createTextVNode(" 回复 ", -1)
                        ]))], 8, _hoisted_44),
                        _createElementVNode("button", {
                          onClick: ($event: any) => (toggleCommentLike(comment)),
                          class: _normalizeClass(['comment-like-btn', { liked: comment.isLiked === 1 }])
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(comment.isLiked === 1 ? 'icon-comment-liked' : 'icon-comment-like')
                          }, null, 2),
                          _createTextVNode(" " + _toDisplayString(comment.likeCount), 1)
                        ], 10, _hoisted_45),
                        (computedUserId.value === comment.userId)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              onClick: _withModifiers(($event: any) => (deleteCurrentComment(comment)), ["stop"]),
                              class: "comment-delete-btn"
                            }, [...(_cache[22] || (_cache[22] = [
                              _createElementVNode("i", { class: "icon-delete" }, null, -1),
                              _createTextVNode(" 删除 ", -1)
                            ]))], 8, _hoisted_46))
                          : _createCommentVNode("", true),
                        (computedUserId.value !== comment.userId)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 2,
                              class: "comment-report-btn",
                              onClick: ($event: any) => (openCommentReportDialog(comment.id))
                            }, [...(_cache[23] || (_cache[23] = [
                              _createElementVNode("i", { class: "icon-report" }, "举报", -1)
                            ]))], 8, _hoisted_47))
                          : _createCommentVNode("", true)
                      ]),
                      (showingReplyInput.value === comment.id)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                            _withDirectives(_createElementVNode("textarea", {
                              "onUpdate:modelValue": ($event: any) => ((replyContents.value[comment.id]) = $event),
                              placeholder: `回复 @${comment.name}...`,
                              class: "comment-textarea",
                              rows: "3"
                            }, null, 8, _hoisted_49), [
                              [_vModelText, replyContents.value[comment.id]]
                            ]),
                            _createElementVNode("div", _hoisted_50, [
                              _createElementVNode("button", {
                                onClick: cancelReply,
                                class: "cancel-btn"
                              }, "取消"),
                              _createElementVNode("button", {
                                onClick: ($event: any) => (submitReply(comment.id, comment.name)),
                                class: "submit-btn",
                                disabled: submittingReply.value
                              }, "回复", 8, _hoisted_51)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (comment.showReplies)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                            _createVNode(ChildCommentList, {
                              postId: getPostId()!,
                              parentId: comment.id,
                              onReportComment: handleReportEvent
                            }, null, 8, ["postId", "parentId"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128)),
                (totalComments.value > 0)
                  ? (_openBlock(), _createBlock(_unref(ElPagination), {
                      key: 0,
                      onCurrentChange: handlePageChange,
                      "current-page": currentPage.value,
                      "page-size": pageSize.value,
                      layout: "prev, pager, next",
                      total: totalComments.value,
                      class: "pagination-container",
                      disabled: commentsLoading.value
                    }, null, 8, ["current-page", "page-size", "total", "disabled"]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_53, "未找到帖子"))
    ]),
    _createVNode(ReportModal, {
      ref_key: "reportModalRef",
      ref: reportModalRef
    }, null, 512),
    _createVNode(EditPostModal, {
      modelValue: editDialogVisible.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((editDialogVisible).value = $event)),
      "post-id": editingPostId.value,
      onSaveSuccess: onEditSuccess
    }, null, 8, ["modelValue", "post-id"]),
    _createVNode(OtherUserProfileModal, {
      modelValue: showUserProfileModal.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((showUserProfileModal).value = $event)),
      userId: selectedUserId.value,
      onClose: _cache[9] || (_cache[9] = ($event: any) => (showUserProfileModal.value = false)),
      onReportUser: _ctx.handleReportUser,
      onFollowStatusChange: _ctx.handleFollowStatusChange
    }, null, 8, ["modelValue", "userId", "onReportUser", "onFollowStatusChange"])
  ], 64))
}
}

})